import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import firebase from 'firebase'
import { loadPen } from '../../../redux/actions/penActions'

const Fork = (props) =>{
  const dispatch = useDispatch()
  const { fork_btn_text } = useSelector(state => state.uiReducer)
  const penReducer = useSelector(state => state.penReducer)
  const { user_data, is_logged_in } = useSelector(state => state.authReducer)

  const { loves, pen_id, love_count } = penReducer

  let loved = is_logged_in ?  loves.find(love => love == user_data.uid) : false
  
  const handlePenLike = () => {
    if(loved || !is_logged_in) return
    firebase.firestore().collection("pens").doc(pen_id).set({
      love_count : love_count + 1,
      loves : firebase.firestore.FieldValue.arrayUnion(user_data.uid)
    },{merge : true}).then(() => {
      dispatch(loadPen({
        ...penReducer,
        love_count : love_count+1,
        loves : [user_data.uid]
      }))
    })
  }
    return (
      <div className='HFBox'>
        <div onClick={handlePenLike} className={`heart ml-5 p-2 cursor-pointer ${!loved && 'hover:bg-gray-500'}`} >
          {/* <img className='heartIcon' src={heart_icon} alt="" /> */}
          <i className={`fa fa-heart fa-2x ${loved ? 'text-red-600' : 'text-gray-800'}`}></i>
        </div>
        <div onClick={props.fork} className='forkBox cursor-pointer hover:bg-gray-500'>
          <p className='fork'>{ fork_btn_text }</p>
          <span className="mr-5"><i className="fa font-2xl fa-code-fork forkIcon" /></span>
        </div>
      </div>
    )
  }

export default Fork


// WEBPACK FOOTER //
// ./src/components/NavBar/components/Fork.js